import { FC, memo } from 'react';
import { IconSize, IconType, IconWrap } from '@tools/ui/dime';
import { TransactionDirection } from '../../../consts/reco.const';

type TProps = {
  direction?: string;
};

const FundsDirection: FC<React.PropsWithChildren<TProps>> = ({ direction }) => {
  const fundsDirection =
    direction?.toLowerCase() === TransactionDirection.Debit
      ? IconType.DebitDirection
      : IconType.CreditDirection;

  return <IconWrap size={IconSize.Small} type={fundsDirection} />;
};
export default memo(FundsDirection);
